import React, { memo } from 'react';
import { Icon, Switch, Tooltip, Typography } from 'antd';
import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useRequestFilterCommands } from '../../../model/commandsContext';
import styles from './FilterSettingsSection.module.scss';

const FilterSettingsSection = () => {
  const dispatch = useDispatch();
  const filterCommands = useRequestFilterCommands();
  const relatedToExpired = useSelector(
    (state) => state.filterStore.relatedToExpired
  );
  const isRelatedToExpiredLoading = useSelector(
    (state) => state.filterStore.isRelatedToExpiredLoading
  );
  const valueCheckedStage = useSelector(
    (state) => state.filterStore.valueCheckedStage
  );
  return (
    <section className={styles.content}>
      <label
        className={cn(styles.switchRow, {
          [styles.active]: relatedToExpired,
        })}
      >
        <Switch
          loading={isRelatedToExpiredLoading}
          checked={relatedToExpired}
          onChange={(newValue) => {
            dispatch(filterCommands.setRelatedToExpired(newValue));
          }}
        />
        <Tooltip
          title="Индикатор просроченных заявок учитывает установки фильтров"
          placement="bottomLeft"
        >
          <Typography.Text className={styles.switchLabel}>
            Для просроченных учитывать фильтр
            <Icon
              type="info-circle"
              className={styles.infoIcon}
            />
          </Typography.Text>
        </Tooltip>
      </label>

      <label
        className={cn(styles.switchRow, {
          [styles.active]: valueCheckedStage,
        })}
      >
        <Switch
          checked={valueCheckedStage}
          onChange={(newValue) => {
            dispatch(filterCommands.setValueCheckedStage(newValue));
          }}
        />
        <Tooltip
          title="Стадии жизненного цикла помещений"
          placement="bottomLeft"
        >
          <Typography.Text className={styles.switchLabel}>
            Стадии ЖЦ
            <Icon
              type="info-circle"
              className={styles.infoIcon}
            />
          </Typography.Text>
        </Tooltip>
      </label>
    </section>
  );
};

export default memo(FilterSettingsSection);
